export default "__VITE_ASSET__DvuOmlnA__"